import React, { FC, useMemo } from 'react';
import classNames from 'classnames';
import { ExtendedGraphData } from './useHistoricGraphData';
import { colorFundMap } from '../savigProfile/graph/savingProfileGraphTheme';
import { formatAmount } from '../../../../../common/util/Functions';

type EstimateLegendProps = {
    legendData: ExtendedGraphData[];
    selectedFunds: string[];
};
const EstimateLegend: FC<EstimateLegendProps> = ({ legendData, selectedFunds }) => {
    const sortedLegendData = useMemo(
        () =>
            legendData.sort((a, b) => {
                const maxA = a.data.series[0].points[a.data.series[0].points.length - 1].y;
                const maxB = b.data.series[0].points[b.data.series[0].points.length - 1].y;
                return maxB - maxA;
            }),
        [legendData]
    );
    return (
        <>
            {sortedLegendData.map((graphData) => {
                const points = graphData.data.series[0].points;
                return (
                    <div
                        className={classNames('legend-row', { '-selected': selectedFunds.includes(graphData.isin) })}
                        key={graphData.isin}
                    >
                        <div style={{ color: colorFundMap[graphData.isin as keyof typeof colorFundMap] }}>
                            <span>{graphData.name}</span>
                        </div>
                        <div>{formatAmount(points[points.length - 1]?.y * 10, true)}</div>
                    </div>
                );
            })}
        </>
    );
};

export default EstimateLegend;
